import { useAuth0 } from '@auth0/auth0-react';

import { PropsWithChildren } from 'react';

export function AuthWrapper({ children }: PropsWithChildren<any>) {
  const { isLoading, isAuthenticated, error, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return null;
  }
  if (error) {
    console.error('Login Error', error);
  }
  if (isAuthenticated) {
    return children;
  }

  // check query param sign_up is set
  const isSignUp = window.location.search.includes('sign_up');

  loginWithRedirect({
    appState: {
      returnTo: window.location.pathname,
      search: window.location.search,
    },
    authorizationParams: {
      screen_hint: isSignUp ? 'signup' : 'login',
    },
  });
}
